import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import './app.css';

import React from 'react';
import ReactDOM from 'react-dom';
import DataGrid from 'devextreme-react/data-grid';
import Layout from './layout/layout.jsx';
import Banner from './banner/banner.jsx'
import Login from './login/login.jsx';

import ruMessages from "devextreme/localization/messages/ru.json";

import { locale, loadMessages, formatMessage } from "devextreme/localization";
import 'devextreme-intl';

export default class App extends React.Component {
    constructor(props) {
        super(props);                
        loadMessages(ruMessages);
        locale(navigator.language);
        this.state = {
            isActive: false,
            isLoading: true
        };
        this.checkTech = this.checkTech.bind(this);
    }

    checkTech() {
        fetch('api/main/CheckTech', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify()
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ isActive: data, isLoading: false });
            });
    }

    componentDidMount() {
        this.checkTech();
    }

    render() {

        var tokenKey = 'accessToken';

        var token = sessionStorage.getItem(tokenKey);

        if (this.state.isLoading) {
            return (
                <div></div>
            )
        }

        if (token && this.state.isActive && JSON.parse(atob(token.split(".")[1])).ManagerLogin != "admin") {
            return (
                <Banner>

                </Banner>
            )
        }
        else if (token && !(JSON.parse(atob(token.split(".")[1])).exp < new Date() / 1000)) {
            return (
                <Layout>

                </Layout>
            );
        }
        else {
            return (
                <Login>
                </Login>
            );
        }
    }
};


// WEBPACK FOOTER //
// ./App/containers/app.jsx